import "animate.css";
import { useEffect, useRef, useState } from "react";
import { Icons } from "utils/iconPath";
import "./style.css";

const SplashScreen = () => {
  // Hooks
  const AnimationRef = useRef();

  // Local States
  const [animationTrue, setAnimationTrue] = useState(true);

  // Effects
  useEffect(() => {
    setTimeout(() => {
      setAnimationTrue(false);
      AnimationRef?.current?.classList?.add("animate__fadeOut");
    }, 3000);
  }, [animationTrue]);

  return (
    <div
      className="SplashScreen animate__animated animate__fadeIn animate__fast"
      ref={AnimationRef}
    >
      <img src={Icons.LOGO} className="splashScreenLogo" alt="Logo" />
    </div>
  );
};

export default SplashScreen;
